import { useAuthedFile } from "@/lib/useAuthedFile";

export default function AuthedImage({ path, alt = "", className = "", fallback = null }) {
  const url = useAuthedFile(path);
  if (!path) return fallback;
  if (!url) {
    return (
      <div className={`bg-muted flex items-center justify-center ${className}`}>
        <span className="text-xs text-muted-foreground">…</span>
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} />;
}
